/** @prettier */
import React from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./TestSummaryBar.css";
import { QuestionResult } from "../Review/testReviewState";

// A specific type for dispatch so it works with both TestReview and TestRunner
type TestSummaryBarDispatch = (action: {
    event: "selectQuestion";
    index: number;
}) => void;

type TestSummaryItemProps = {
    index: number;
    dispatch: TestSummaryBarDispatch;
    current: boolean;
    /**
     * Is the question correct, incorrect, or unanswered?
     * Can be none of the above, in the case of a running test
     **/
    result?: QuestionResult;
    isFlagged: boolean;
    isFiltered?: boolean;
};
export const TestSummaryItem = ({
    dispatch,
    result,
    ...props
}: TestSummaryItemProps) => (
    <div
        className={classNames("tr-summary-item", {
            active: props.current,
            filtered: props.isFiltered,
        })}
    >
        <button
            disabled={props.current || props.isFiltered}
            title={`Go to question ${props.index + 1}`}
            onClick={() =>
                dispatch({ event: "selectQuestion", index: props.index })
            }
        >
            {result && (
                <div
                    className={classNames(
                        "tr-summary-result",
                        result.toLowerCase(),
                    )}
                >
                    <FontAwesomeIcon
                        icon={
                            result === "UNANSWERED"
                                ? "exclamation"
                                : result === "CORRECT"
                                ? ["far", "check-circle"]
                                : ["far", "times-circle"]
                        }
                    />
                </div>
            )}
            {props.index + 1}
            {/* Nested inside button, so it doesn't block clicking */}
            {props.isFlagged && (
                <div className="tr-summary-badge">
                    <FontAwesomeIcon icon={["far", "flag"]} />
                </div>
            )}
        </button>
    </div>
);
